import React from 'react'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { getAge } from '../../../utils/dates'
import { Box, Stack } from '@mui/material'
import { getPatientBirthCity, getPatientSexLabel } from './_utils'
import { PatientInfoHistoryProps } from './_props'

dayjs.extend(utc)
dayjs.extend(timezone)

const PatientInfoHistory = ({ patient }: PatientInfoHistoryProps) => (
    <Box>
        <Stack gap="1rem">
            <Typography variant="h5">
                <b>{patient.fullName}</b>
            </Typography>
            <Typography variant="h6">
                {`Né le ${dayjs(patient.birthDate).format('DD/MM/YYYY')} - ${getAge(patient.birthDate)} ans`}
            </Typography>
            <Typography variant="h6">{`Sexe : ${getPatientSexLabel(patient.sex)}`}</Typography>
            <Typography variant="h6">
                {`1er Prénom de naissance et autres prénoms de naissance : ${patient.firstNameList?.join(', ')}`}
            </Typography>
            <Typography variant="h6">{`Lieu de naissance : ${getPatientBirthCity(
                patient.birthCity,
                patient.countryBirth,
            )}`}</Typography>
            <Typography variant="h6">{`Chambre : ${patient.room || '-'}`}</Typography>
            <Typography variant="h6">{`Médecin traitant : ${patient.attendingPhysician}`}</Typography>
        </Stack>
        <Typography
            variant="h6"
            sx={{
                fontStyle: 'italic',
                fontSize: '.75rem',
                marginTop: '1.1rem',
            }}
        >
            {patient.lastAction}
        </Typography>
    </Box>
)

export default PatientInfoHistory
